import { Component, OnInit } from '@angular/core';
import { Router } from "@angular/router";
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { SliderOutputDto, SliderService } from 'src/generated_client';
import { SnackBarService } from 'src/app/services/snack-bar.service';

@Component({
  selector: 'app-edit-slider',
  templateUrl: './edit-slider.component.html',
  styleUrls: ['./edit-slider.component.css']
})

export class EditSliderComponent implements OnInit {

  editSliderForm: FormGroup = this.fb.group({

    titulo: ['', Validators.required],
    imagen: [''],
    nroOrden: ['', Validators.required],
    dsimagen: ['']
  })

  sliderOutput: SliderOutputDto = {} as SliderOutputDto;
  id: any;

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private sliderService: SliderService,
    private snackBar: SnackBarService
  ) { }

  ngOnInit(): void {

    this.id = this.activatedRoute.snapshot.paramMap.get("id");

    this.sliderService.apiSliderGetOneGet(this.id).subscribe(x => {

      this.editSliderForm.controls['titulo'].setValue(x.dsTitle);
      this.editSliderForm.controls['imagen'].setValue(x.dsImg);
      this.editSliderForm.controls['dsimagen'].setValue(x.dsImg);
      this.editSliderForm.controls['nroOrden'].setValue(x.nmSortNo);
    })
  }

  get DsImage() {
    return this.editSliderForm.controls['dsimagen'].value;
  }

  saveChanges(form: any) {
    var imagen: File = form.imagen?._files;

    if (imagen != undefined)
      imagen = form.imagen?._files[0];

    this.sliderService.apiSliderEditPutForm(this.id, form.titulo, form.nroOrden, imagen, undefined).subscribe(() => {

      this.router.navigate(['start-slider']);
      this.snackBar.openSnackBar('Los cambios fueron guardados', 'Aceptar')
    },
      err => {

        this.snackBar.openSnackBar('Ocurrió un error y los cambios no pudieron guardarse', 'Aceptar')
      }
    )
  }

}
